
import Vue from 'vue';
import MenuOrBottomSheet from '../../../../../components/base/MenuOrBottomSheet.vue';
import { WhatsNewUpdate } from "@run-diffusion/shared";
import { getUtcMoment } from '@/utils';

export default Vue.extend({
	name: 'VersionSelector',
	components: {
		MenuOrBottomSheet
	},
	props: {
		versions: {
			type: Array as () => WhatsNewUpdate[],
			required: true
		},
		selectedVersionIndex: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			isOpen: false
		};
	},
	computed: {
		selectedVersion(): string {
			if (this.versions.length === 0) return '';
			const version = this.versions[this.selectedVersionIndex];
			return version.date ? getUtcMoment(version.date.toMillis()).format('MMMM D, YYYY') : '';
		},
	},
	methods: {
		getUtcMoment,
		selectVersion(index: number, close: () => void) {
			this.$emit('version-selected', index);
			close();
		},
	}
});
